module.exports = __webpack_public_path__ + "img/yu-three.13848e66.png";